module.exports = __webpack_public_path__ + "static/fonts/materialdesignicons-webfont.2dcce27.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fonts/materialdesignicons-webfont.woff?v=5.1.45
// module id = ZzMk
// module chunks = 1